import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const RoleBaseRoute = () => {
  const auth = useSelector((state: any) => state.auth);
  return auth?.loginData?.user_type === "support" ? (
    <Navigate to={"/prizeFullfillment"} />
  ) : (
    <Navigate to={"/"} />
  );
};
export default RoleBaseRoute;
